export const SYMPTOM_TYPES = [
  'CONSTIPATION',
  'HEADACHE',
  'LOW_ENERGY',
  'INSOMNIA',
  'SELF_CRITICAL',
  'BLOATING',
  'LOST',
  'GUILT',
  'CRAMPS',
  'POST_PARTUM',
  'MOOD_SWINGS',
  'ACNE',
  'VAGINAL_DRYNESS',
  'SAD',
  'ABDOMINAL_PAIN',
  'HEAVY_FLOW',
  'IRRITABILITY',
  'BREAST_TENDERNESS',
  'DIARRHEA',
  'FATIGUE',
  'BACK_PAIN',
  'LETHARGIC',
  'LOW_LIBIDO',
  'DEPRESSED',
  'OBSESSIVE_THOUGHTS',
  'IRREGULAR_FLOW',
  'VAGINAL_ITCHING',
  'IRREGULAR_CYCLE',
  'ANXIOUS',
  'NAUSEA',
  'CRAVINGS',
];

export type RecommendationFormState = {
  textFr: string;
  textEn: string;
  whyFr: string;
  whyEn: string;
  symptomTypes: string[];
};

export const emptyRecommendationForm = (): RecommendationFormState => ({
  textFr: '',
  textEn: '',
  whyFr: '',
  whyEn: '',
  symptomTypes: [],
});

type RecommendationFormProps = {
  state: RecommendationFormState;
  onChange: (state: RecommendationFormState) => void;
};

export const RecommendationForm = ({
  state,
  onChange,
}: RecommendationFormProps) => {
  const toggleSymptom = (type: string) => {
    const next = state.symptomTypes.includes(type)
      ? state.symptomTypes.filter((s) => s !== type)
      : [...state.symptomTypes, type];
    onChange({ ...state, symptomTypes: next });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-sm font-medium mb-1 block">Texte (FR) *</label>
          <textarea
            className="w-full border rounded px-3 py-2 text-sm resize-none min-h-20"
            placeholder="Texte de la recommandation en français"
            value={state.textFr}
            onChange={(e) => onChange({ ...state, textFr: e.target.value })}
          />
        </div>
        <div>
          <label className="text-sm font-medium mb-1 block">Texte (EN) *</label>
          <textarea
            className="w-full border rounded px-3 py-2 text-sm resize-none min-h-20"
            placeholder="Recommendation text in english"
            value={state.textEn}
            onChange={(e) => onChange({ ...state, textEn: e.target.value })}
          />
        </div>
        <div>
          <label className="text-sm font-medium mb-1 block">
            Pourquoi (FR) *
          </label>
          <textarea
            className="w-full border rounded px-3 py-2 text-sm resize-none min-h-20"
            placeholder="Explication en français"
            value={state.whyFr}
            onChange={(e) => onChange({ ...state, whyFr: e.target.value })}
          />
        </div>
        <div>
          <label className="text-sm font-medium mb-1 block">
            Pourquoi (EN) *
          </label>
          <textarea
            className="w-full border rounded px-3 py-2 text-sm resize-none min-h-20"
            placeholder="Explanation in english"
            value={state.whyEn}
            onChange={(e) => onChange({ ...state, whyEn: e.target.value })}
          />
        </div>
      </div>

      <div>
        <label className="text-sm font-medium mb-2 block">Symptômes *</label>
        <div className="grid grid-cols-2 gap-1 max-h-48 overflow-y-auto border rounded p-2">
          {SYMPTOM_TYPES.map((type) => (
            <label
              key={type}
              className="flex items-center gap-2 text-sm cursor-pointer hover:bg-zinc-50 px-1 py-0.5 rounded"
            >
              <input
                type="checkbox"
                checked={state.symptomTypes.includes(type)}
                onChange={() => toggleSymptom(type)}
              />
              {type}
            </label>
          ))}
        </div>
        {state.symptomTypes.length > 0 && (
          <p className="text-xs text-zinc-500 mt-1">
            {state.symptomTypes.length} sélectionné(s)
          </p>
        )}
      </div>
    </div>
  );
};
